import Vue from 'vue';
import moment from 'moment';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate/dist/vee-validate.full';

extend('date', {
  message: 'Enter date in format MM/DD/YYYY',
  validate: (value) => {
    return moment(value, 'MM/DD/YYYY', true).isValid();
  },
});

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
